import styled from 'styled-components';
import { Base, Theme } from 'styled';

export const Wrapper = styled(Base)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  ${({ theme }) => theme.typography.variants.primary.xs};
`;

export const Container = styled(Base)`
  display: flex;
  flex-direction: column;
  align-items: start;
`;

export const InlineLinkContainer = styled(Base)`
  display: inline;

  a {
    display: inline !important;
  }
`;

export const Avatar = styled(Base)`
  height: 2.25rem;
  width: 2.25rem;
  min-width: 2.25rem;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 0.5rem;
`;

export const InnerContainer = styled(Base)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const AuthorReviewerContainer = styled(Base)`
  display: flex;
  flex-direction: column;
  margin: 0.75rem 0;
`;

export const PracticeNameContainer = styled(Base)`
  margin-top: 0.5rem;
`;

export const TextContainer = styled(Base)`
  color: ${({ theme }) => theme.palette.text.primary};
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: left;
  margin: '1.5rem 0';

  ${Theme.mediaQueries.sm} {
    margin: '1.5rem 0 2.5rem';
  }

  ${Theme.mediaQueries.md} {
    margin: '3.5rem 0 2.5rem';
  }
  padding-bottom: 1rem;
`;

export const DateContainer = styled(Base)`
  margin: '1.5rem 0';
  display: flex;
  flex-direction: column;
`;
